import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { KeypadService } from "../services/KeyPadService";
// import { gameService } from "../../global";

// import { GameEventService } from "../services/GameEventService";

const styles: string = css`
 .keypad {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    color: #ff4081; /* vrolijke roze tint */
    font-family: 'Comic Sans MS', cursive, sans-serif; /* speels lettertype */
  }

  .numpad {
    display: grid;
    grid-template-columns: repeat(3, 70px);
    gap: 10px;
  }

  .numpad button {
    width: 70px;
    height: 70px;
    background: linear-gradient(145deg, #ff80ab, #ff4081);
    color: white;
    font-size: 1.6em;
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.1s ease;
  }

  .numpad button:hover {
    transform: scale(1.05);
  }

  .numpad button:active {
    transform: scale(0.95);
  }

  .lcd {
    display: flex;
    gap: 6px;
    background-color: #222;
    padding: 8px 12px;
    border-radius: 8px;
    box-shadow: inset 0 0 5px #000;
  }

  .lcd > div {
    width: 32px;
    height: 40px;
    background-color: #444;
    color: #0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
  }
`;

export class BackpackCaseComponent extends HTMLElement {
    private gameEventService: GameEventService = new GameEventService();
    private keypadService: KeypadService = new KeypadService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }
        const element: HTMLElement = this.renderKeypad();

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderKeypad(): HTMLElement {
        const element: HTMLElement = html`

       <div>
        <style>${styles}</style>
        <div class="keypad">
          <div class="lcd">
            <div>.</div>
            <div>.</div>
            <div>.</div>
            <div>.</div>
          </div>
          <div class="numpad">
            <button>7</button>
            <button>8</button>
            <button>9</button>
            <button>4</button>
            <button>5</button>
            <button>6</button>
            <button>1</button>
            <button>2</button>
            <button>3</button>
            <button>X</button>
            <button>0</button>
            <button>&gt;</button>
          </div>
        </div>
      </div>
    

        `;

        const lcNodes: NodeListOf<HTMLElement> = element.querySelectorAll(".lcd > div");
        let currentkey: number = 0;

        element.querySelectorAll("button").forEach(e => {
            const key: string = e.innerText;

            e.addEventListener("click", async () => {
                if (key === "<") {
                    currentkey--;

                    if (currentkey < 0) {
                        currentkey = 0;
                    }

                    lcNodes[currentkey].innerText = ".";
                }
                else if (key === "X") {
                    this.gameEventService.switchPage(Page.Canvas);
                }
                else if (key === ">") {
                    if (currentkey < 4) {
                        return;
                    }
                    // verbergt tijdelijk alle tekens
                    lcNodes.forEach(f => f.style.display = "none");

                    // haalt de ingevulde code op
                    const code: string = Array.from(lcNodes).map(node => node.innerText).join("");

                    const isCodeCorrect: boolean = await this.keypadService.handleCheckCode(code);
                    if (isCodeCorrect) {
                        lcNodes[0].style.display = "block";
                        lcNodes[0].innerText = "OK";
                    }
                    else {
                        lcNodes[0].style.display = "block";
                        lcNodes[0].innerText = "ERROR";
                    }
                }
                else {
                    if (currentkey > 3) {
                        return;
                    }

                    lcNodes[currentkey].innerText = key;

                    currentkey++;
                }
            }

            );
        }

        );
        return element;
    }
}
